module.exports = __webpack_public_path__ + "static/media/Protein Cookies 200g.41d7d08e.jpg";